/**
 * Element to display brief pieces of information / notifications to the user.
 * It has no public properties or attributes.
 * The content are the children of the 'fit-toaster' element
 *
 * @element fit-toaster
 */
class FitToaster extends HTMLElement {
  static get is() { return 'fit-toaster'; }

  constructor(props) {
    super(props);
    this.isToasting = false;
    this._openedToasts = [];
  }

  connectedCallback() {
    customElements.whenDefined('fit-toast').then(() => {
      this.addEventListener('fit-toast-closed', this._openNextToast);
      this._mutationObserver = new MutationObserver(this._openNextToast.bind(this));
      this._mutationObserver.observe(this, { childList: true });
      this._openNextToast();
    });
  }

  disconnectedCallback() {
    if (this._mutationObserver) {
      this._mutationObserver.disconnect();
      this._mutationObserver = null;
    }
  }

  _openNextToast(event) {
    if (event instanceof Event && event.type === 'fit-toast-closed') {
      this.isToasting = false;
    }

    if (this.isToasting) {
      return;
    }

    const toasts = Array.prototype.slice.call(this.querySelectorAll('fit-toast'));
    let toast;
    while ((toast = toasts.shift())) {
      if (this._openedToasts.includes(toast)) {
        continue;
      }
      this._openedToasts.push(toast);
      this.isToasting = true;
      requestIdleCallback(() => {
        toast.open();
      });
      return;
    }
  }
}

customElements.define(FitToaster.is, FitToaster);
